/** Switches one key in a filter selection, returning a new set so state updates are detected. */
export const toggled = (selection: ReadonlySet<string>, key: string): ReadonlySet<string> => {
  const next = new Set(selection);
  if (next.has(key)) {
    next.delete(key);
  } else {
    next.add(key);
  }
  return next;
};
